// @ts-strict-ignore
import React from 'react'
import { RichText } from '../../../helpers/react'
import { useEntities, useEntity } from '../../../helpers/selectors'
import { Icon } from '../../../../atoms'
import Image from '../../../imgix-img'
import { removeWhitespaceAndSpecialChars } from '../../../helpers/commons'
import { connect } from 'react-redux'
import { brand } from '../../../../redux/app-selectors'

interface Item {
  title: string
  content: string
  icon: any
}

interface AccordionProps {
  title: string
  name: string
  items: Array<object>
  brand: 'money' | 'uswitch' | 'confused'
  variant: string
  sys: { id: string }
}

const AccordionImage = (props: any) => {
  const { ele } = props
  const iconImage = useEntity(ele.icon)

  return (
    <>
      {iconImage.file && (
        <div className='accordion__img-mobile'>
          <Image src={iconImage.file.url} alt={ele.title} width={20} />
        </div>
      )}
    </>
  )
}

const iconColor = (brand: AccordionProps['brand'], variant: AccordionProps['variant']): string => {
  switch (brand) {
    case 'money':
      return '#924A8B'
    case 'confused':
      return variant === 'platinum' ? 'white' : '#1F1F1F'
    default:
      return '#141414'
  }
}

const Accordion = ({ name, title, items, brand, variant, sys }: AccordionProps) => {
  const data = useEntities(items)
  const brandWithVariantClassNameAffix = brand + '-' + variant

  const dataTracking = (title?) => ({
    component_category: 'component',
    component_id: sys?.id,
    component_name: 'PlatinumAccordion',
    contentful_name: name,
    contentful_variant: variant,
    event_name: 'Accordion Clicked',
    additionalProps: {
      title,
    },
  })

  return (
    <div className='accordion' id={removeWhitespaceAndSpecialChars(name)}>
      {title && <h2 className={`accordion__heading ${brand + '-heading'}`}>{title}</h2>}
      {data.map((ele: Item, i: number) => (
        <details key={i}>
          <summary
            className={`${brandWithVariantClassNameAffix}-summary`}
            data-click-accordion-tracking={JSON.stringify(dataTracking(ele.title))}
          >
            <div className='accordion__icon closed'>
              <Icon
                glyph={brand === 'confused' ? 'plus' : 'arrow-down'}
                size={24}
                color={iconColor(brand, variant)}
              />
            </div>
            <div className='accordion__icon opened'>
              <Icon
                glyph={brand === 'confused' ? 'minus' : 'arrow-up'}
                size={24}
                color={iconColor(brand, variant)}
              />
            </div>
            <span className={`accordion__title ${brandWithVariantClassNameAffix + '-title'}`}>
              {ele.icon && <AccordionImage ele={ele} />}
              <h3>{ele.title}</h3>
            </span>
          </summary>
          <div className='accordion__content'>
            <RichText content={ele.content} />
          </div>
        </details>
      ))}
    </div>
  )
}

export default connect((state, props) => {
  return {
    brand: brand(state),
    ...props,
  }
})(Accordion)
